import { DbService } from '../db/db.service';

export abstract class ProjectFirestoreService {
  protected constructor(protected db: DbService) {}

  protected projectDoc(projectId: string, path: string) {
    return this.db.firestore
      .collection(path)
      .doc(projectId);
  }

  protected projectCollection(projectId: string, path: string, collection: string) {
    return this.projectDoc(projectId, path).collection(collection);
  }
}